import {
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader, MDBModalTitle,
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState, } from "react";
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../context/CartProvider';
import { MiscContext } from '../context/MiscProvider';
const UserMessagesModal = ({messages,isFromDomain,status}) => {
  const navigate = useNavigate();
  const [basicModal, setBasicModal] = useState(messages && messages.length > 0);
  const { isContactPage} = useContext(MiscContext);
  const {  setOrders} = useContext(CartContext);
    const toggleShow = () => setBasicModal(!basicModal);
    useEffect(() => {
      if (messages && messages.length > 0) {
        setBasicModal(true);
      }
    }, [messages]);
    const containsSuccessMessage = messages?.some(message => message.toLowerCase().includes('success')) || status === 'AUTHORIZED';

    return (
   
    
                 <MDBModal tabIndex={-1} open={basicModal} setOpen={setBasicModal} nonInvasive={true} staticBackdrop>
        <MDBModalDialog centered={true}>
          <MDBModalContent >
{/*             
            <MDBModalHeader className={`text-light ${status === 'AUTHORIZED' ? 'bg-primary' : 'bg-danger'} text-center`}> */}
            <MDBModalHeader className={`text-light ${containsSuccessMessage ? 'bg-primary' : 'bg-danger'} text-center`}>


            <MDBModalTitle>  <MDBIcon fas icon={containsSuccessMessage ? 'check-circle' : 'times-circle'} className='ml-1 me-2 color-light'/> Info </MDBModalTitle>
            <MDBBtn className='btn-close-white btn-close' color="none" aria-label="Close"  onClick={()=>{setBasicModal(false);isContactPage && isContactPage(false);status !== 'AUTHORIZED' && setOrders(undefined)}} ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>  <ul>
              { messages?.map((message, index) => (
                <li key={index}>{message}</li>
              ))}
            </ul></MDBModalBody>

            <MDBModalFooter>
            {/* <Link to='/home' color='none'> 
              <MDBIcon fas icon="home" className="fa-fw me-3 " color='primary' /> 
              
            </Link> */}
{/* 
            <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#3b5998' }}>
        <MDBIcon fab icon='facebook-f' size='lg' />
      </MDBBtn> */}
        </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
       
      </MDBModal>


    );
              };

UserMessagesModal.propTypes = {

    messages: PropTypes.array,
    isFromDomain:PropTypes.bool,
    status: PropTypes.string,
  
  };
  
  export default UserMessagesModal;